module.exports = __webpack_public_path__ + "static/media/insite_intelligence.4d3a1f19.svg";